export const RECEIVING_ITEM_MODAL_HEIGHT = 540;
